import React, { Fragment, useState } from "react";
import { NavLink } from "react-router-dom";
import CheckoutForm from "./CheckoutForm";
import Canvas from "./OffCanvas";

const CartCard = ({ productImg, productName }) => {
  const [removeCartItem, setRemoveCartItem] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [price, setPrice] = useState(0);

  const [showOffCanvas, setShowOffCanvas] = useState(false);

  const toggleOffCanvas = () => {
    setShowOffCanvas(!showOffCanvas);
  };

  const handleChange = (e) => {
    setQuantity(e.target.value);
    setPrice(e.target.value * 3000);
  };

  const removeItemFromCart = () => {
    setRemoveCartItem(true);
  };
  return (
    <Fragment>
      {showOffCanvas && (
        <Canvas
          canvasTitle="Thank You For Shopping with us 🛒"
          onRequestClose={toggleOffCanvas}
          canvasComponent={
            <CheckoutForm
              productName={productName}
              productQuantity={quantity}
              amount={price}
            />
          }
        />
      )}
      <div className={`flex gap-4 ${removeCartItem && `hidden`}`}>
        <div className="bg-orange-100 p-4 flex justify-between gap-4 flex-wrap items-center mt-4 w-full rounded-lg">
          <div>
            <img
              src={productImg}
              alt="Abstract Journal Design"
              className="w-12 rounded-lg"
            />
          </div>
          <h3 className="text-base w-2/3 md:w-max">{productName}</h3>
          <div className="flex gap-4">
            <input
              type="number"
              name="productQuantity"
              className="bg-white border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full py-2 text-center"
              placeholder="Quantity"
              value={quantity}
              onChange={handleChange}
            />
          </div>
          <p className="font-bold text-lg">₦{price}</p>
        </div>
        <i
          className="bi bi-x-circle-fill cursor-pointer self-center"
          onClick={removeItemFromCart}
        ></i>
      </div>
      <div className={`mt-4 ${removeCartItem ? `block` : `hidden`}`}>
        <NavLink to={"/store"}>
          <button
            className={`bg-dark-blue myShadow px-4 py-3 md:px-8 md:py-2.5 flex gap-2 text-white hover:bg-none rounded-md disabled:opacity-50`}
            onClick={toggleOffCanvas}
          >
            <div className="self-center">
              <i className="bi bi-bag"></i>
            </div>
            Back to store.
          </button>
        </NavLink>
      </div>
      <div
        className={`mt-4 flex gap-4 flex-col md:flex-row ${
          removeCartItem ? `hidden` : `block`
        }`}
      >
        <button
          className={`bg-dark-blue myShadow px-4 py-3 md:px-8 md:py-2.5 flex gap-2 justify-center text-white hover:bg-none rounded-md disabled:opacity-50`}
          onClick={toggleOffCanvas}
        >
          <div className="self-center">
            <i className="bi bi-bag"></i>
          </div>
          Checkout With Paystack
        </button>
        <a
          href="https://tinyurl.com/halaprofile/the360believer"
          target={"_blank"}
          rel="noreferrer"
        >
          <button
            className={`bg-white myShadow px-4 py-3 md:px-8 md:py-2.5 flex gap-2 justify-center text-dark-blue hover:bg-none rounded-md disabled:opacity-50`}
          >
            <div className="self-center">
              <i class="bi bi-box-arrow-up-right"></i>
            </div>
            Pay With Hala
          </button>
        </a>
      </div>
    </Fragment>
  );
};

export default CartCard;
